import React from "react";
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  Button: {
    padding: '14px 20px',
    border: 'none',
    backgroundColor: '#242836',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '600',
    color: '#f6f8ff',
    cursor: 'pointer',
    outline: 'none',
    transform: 'scale(1)',
    transition: 'transform 0.2s, background 0.4s'
  },
  '& Button:hover, Button:focus': {
    backgroundColor: '#2f3545',
    transform: 'scale(1.02)'
  },
  
  '& Button:focus': {
    boxShadow: '0 0 0 4px #4c9ffe'
  },
  
  '& Button:active': {
    transform: 'scale(0.95)'
  }
}));

export function Button({ children, ...props }) {
  const styles = useStyles();
  return (
    <button
      className={styles.Button}
      style={{ background: "red" }}
      {...props}
    >
      {children}
    </button>
  );
}
